import { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { LayoutStandard } from "components";
import { AppConstants, AuthorityConstants } from "constant";
import { UserResponse } from "types";
import { AppUtils, StorageUtils, UserUtils } from "utils";

import AdminDashboard from "./admin/AdminDashboard";
import AgentDashboard from "./agent/AgentDashboard";
import TeamLeadDashboard from "./team-lead/TeamLeadDashboard";

const { STORAGE_USER } = AppConstants;
const DASHBOARD_VIEW_QUERY_KEY = "ansicht";
const TEAM_LEAD_DASHBOARD_QUERY_VALUE = "team-lead";
const DASHBOARD_AUTHORITIES = [
  AuthorityConstants.ROLE_DASH_ADMIN,
  AuthorityConstants.ROLE_DASH_ADMINISTRATOR,
  AuthorityConstants.ROLE_DASH_AGENT,
];

const DashboardPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [user] = useState<UserResponse | undefined>(StorageUtils.getObject(STORAGE_USER));
  const primaryDashboardVariant = useMemo(() => UserUtils.getDashboardVariant(user), [user]);
  const shouldShowTeamLeadDashboard =
    user?.isTeamLead &&
    searchParams.get(DASHBOARD_VIEW_QUERY_KEY) === TEAM_LEAD_DASHBOARD_QUERY_VALUE;

  return (
    <LayoutStandard
      authority={DASHBOARD_AUTHORITIES}
      title={AppUtils.composeTabTitle(t("header.dashboard"))}
      padding={0}
    >
      {shouldShowTeamLeadDashboard ? (
        <TeamLeadDashboard scope="teamLead" />
      ) : (
        <>
          {primaryDashboardVariant === "ADMIN" && <AdminDashboard />}
          {primaryDashboardVariant === "ADMINISTRATOR" && <AdminDashboard scope="administrator" />}
          {primaryDashboardVariant === "AGENT" && <AgentDashboard />}
        </>
      )}
    </LayoutStandard>
  );
};

export default DashboardPage;
